import { render, staticRenderFns } from "./SelectableTable.vue?vue&type=template&id=2b2703bd&scoped=true&"
import script from "./SelectableTable.vue?vue&type=script&lang=js&"
export * from "./SelectableTable.vue?vue&type=script&lang=js&"
import style0 from "./SelectableTable.vue?vue&type=style&index=0&id=2b2703bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2703bd",
  null
  
)

export default component.exports